
export default {
  inheritAttrs: false,
  props: {
    hours: {
      type: Array,
      default: null
    }
  },
  computed: {
    data() {
      return this.hours || this.$contact.businessHours
    }
  }
}
